import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthStateService } from './services/auth-state.service';
import { LoadingComponent } from 'shared-ui';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  template: `
    <div class="app-shell bg-zinc-50 text-zinc-950 transition-colors duration-200 dark:bg-zinc-950 dark:text-zinc-50">
      @if (authLoading()) {
        <app-loading></app-loading>
      }
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [`
    :host,
    .app-shell {
      display: block;
      width: 100%;
      height: 100%;
    }
  `],
})
export class App {
  private readonly authStateService = inject(AuthStateService);

  authLoading = signal(false);

  async ngOnInit(): Promise<void> {
    this.restoreTheme();
    this.authStateService.restoreSession().subscribe();
    this.authStateService.loading$.subscribe(loading => {
      this.authLoading.set(loading);
    });
  }

  private restoreTheme(): void {
    const storedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    document.documentElement.classList.toggle('dark', storedTheme ? storedTheme === 'dark' : prefersDark);
  }

}
